<script>

import bus from 'vue3-eventbus';
import ToastMessages from "../classes/ToastMessages.ts";

export default {
    emits: [
        'deleteFromCart'
    ],
    props: {
        item: Object,
        id: String
    },
    data() {
        return {
            messages: []
        }
    },
    mounted() {
        bus.on('toastMessage', e => this.queueMessage(e));
    },
    methods: {
        queueMessage(message) {
            this.messages.push(message);

            if (message.timeout) {
                new Promise((resolve, reject) => {
                    setTimeout(() => {
                        resolve(message);
                    }, message.timeout);
                }).then(resolved => {
                    this.dismissMessage(resolved)
                });
            }
        },
        dismissMessage(dismissedMessage) {
            this.messages = this.messages.filter(message => message.id !== dismissedMessage.id);
        }
    }
}
</script>
<template>
    <div class="cart-toast">
        <template v-for="message in messages">
            <div v-if="!message.targetId && !id || message.targetId === id">
                <div class="alert" :class="message.cssClass" @click="dismissMessage(message)">
                    <img v-if="message.icon" :src="message.icon">
                    <span v-html="message.description"></span>
                    <button v-if="message.dismiss" type="button" @click="dismissMessage(message)" class="btn"><i class="fa fa-times"></i></button>
                </div>
            </div>
        </template>
    </div>
</template>
